// External deps
import { useContext } from 'react';
import { Button, Input, ContentCard, InputPassword } from 'ypf-pas-general-ui-components';
import { Form } from 'react-bootstrap';
import { useFormik } from 'formik';
import * as yup from 'yup';

// Internal deps
import LogoPas from '../../assets/images/logo-yclick-vertical.svg';
import LoaderContext from '../../context/LoaderProvider';
import { useAppContext } from '../../context/AppProvider';
import useToast from '../../hooks/useToast';
import { loginService2 } from '../../services/login';

import './Login.scss';
import LoginHelper from './utils/LoginHelper';

const schemaFilters = yup.object().shape({
  user: yup
    .string()
    .required('Debe ingresar usuario')
    .max(50, 'Se permite hasta 50 caracteres')
    .min(5, 'Debe ingresar al menos 5 caracteres'),
  password: yup
    .string()
    .required('Debe ingresar contraseña')
    .max(50, 'Se permite hasta 50 caracteres')
    .min(5, 'Debe ingresar al menos 5 caracteres')
});

const Login = () => {
  const { setLoader, loader } = useContext(LoaderContext);
  const { setNewToast } = useToast();
  const { authUser } = useAppContext();

  const loginUser = async (params) => {
    try {
      setLoader(true);
      const response = await loginService2({
        userName: params.user,
        password: params.password
      });
      const accessTokenData = {
        access_token: response.accessToken,
        expires_in: response.expiresIn,
        refresh_token: response.refreshToken
      };

      authUser(accessTokenData, Math.floor(new Date().getTime() / 1000), true);
      setLoader(false);
    } catch (err) {
      setLoader(false);
      setNewToast({
        type: 'ERROR',
        message: err.message
      });
    }
  };

  const formik = useFormik({
    initialValues: {
      user: '',
      password: ''
    },
    validationSchema: schemaFilters
  });

  const { values, setFieldValue, isValid } = formik;

  const isDev = process.env.NODE_ENV === 'development';

  return (
    <div className="login-page">
      {!!isDev && <LoginHelper formik={formik} />}

      <div className="centered-container">
        <img alt="Logo Pas" src={LogoPas} />
        <ContentCard orientation="horizontal">
          <>
            <h4>Bienvenido</h4>
            <Form className="text-center w-100">
              <Input
                label="Usuario"
                maxLength={50}
                name="user"
                onChange={(e) => {
                  setFieldValue('user', e.target.value.trim());
                }}
                placeholder="Ingrese usuario"
                testid="login-input-user"
                type="text"
                value={values.user}
              />
              <InputPassword
                className="mt-3"
                label="Contraseña"
                maxLength={50}
                name="password"
                onChange={(e) => {
                  setFieldValue('password', e.target.value.trim());
                }}
                placeholder="Ingrese contraseña"
                showIcon
                type="password"
                value={values.password}
              />

              <div className="d-flex justify-content-start forget-password-container mb-3">
                <a href="https://ssofed.ypf.com/ufpw/recupero_clave_cp" target="a_blank">
                  <span>¿Olvidaste tu contraseña?</span>
                </a>
              </div>

              <Button
                className="my-2"
                disabled={!isValid || loader}
                label="Ingresar"
                onClick={() => loginUser(values)}
                type="button"
                variant="primary"
                widthButton="100%"
              />
            </Form>
          </>
        </ContentCard>
      </div>
    </div>
  );
};

export default Login;
